module.exports = "/_next/static/images/aditya2-e20b70ad859ca1138c4fe8a9bb63dbc4.png";